import Scene from './Scene';
import common from '../common';
import {translate, Text} from '../utils';

export default class PauseScene extends Scene {
	init() {
		super.init();

		const bg = new PIXI.Sprite(P3.assets.texture('ui_bg_1'));
		bg.anchor.set(0.5);
		bg.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5));
		bg.width = 2000;
		bg.interactive = true;
		this.addChild(bg);

		this.bg = bg;

		for (let i = 0; i < 4; i++) {
			const codetile = new PIXI.Sprite(P3.assets.texture('ui_bg_1_tile'));
			codetile.anchor.set(0, 0.5);
			codetile.position.set(-68 + (i * 450), (common.STAGE_HEIGHT * 0.5));
			this.addChild(codetile);
		}

		this._createVerticalLines(12);
		this._createHorizontalLines(4);

		const frameTop = new PIXI.Container();
		frameTop.rotation = 180 * PIXI.DEG_TO_RAD;
		this.addChild(frameTop);

		const frameTop1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop1.anchor.set(0, 0);
		frameTop1.scale.x = -1;
		frameTop.addChild(frameTop1);

		const frameTop2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop2.anchor.set(0, 0);
		frameTop.addChild(frameTop2);

		const frameBottom = new PIXI.Container();
		this.addChild(frameBottom);

		const frameBottom1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom1.anchor.set(1, 1);
		frameBottom.addChild(frameBottom1);

		const frameBottom2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom2.anchor.set(1, 1);
		frameBottom2.scale.x = -1;
		frameBottom.addChild(frameBottom2);

		frameBottom.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT);
		frameTop.position.set((common.STAGE_WIDTH * 0.5), frameTop.height);

		const titletext = Text(`// ${translate('MENU.PAUSE.TITLE')}`, {font: '48px ZCOOL QingKe HuangYou', align: 'center'});
		titletext.tint = 0xB3FF47;
		titletext.anchor.set(0.5);
		titletext.position.set((common.STAGE_WIDTH * 0.5), 60);
		this.addChild(titletext);

		const caretText = Text('_', {font: '48px ZCOOL QingKe HuangYou', align: 'center'});
		caretText.tint = 0xB3FF47;
		caretText.anchor.set(0, 0.5);
		caretText.position.set(titletext.x + (titletext.width * 0.5) + 10, 62);
		this.addChild(caretText);

		new P3.utils.TWEEN.Tween(caretText, this.tweens)
			.to({
				alpha: 0
			}, 1)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(500)
			.yoyo(true)
			.repeat(Infinity)
			.start();

		const blob = new PIXI.Sprite(P3.assets.texture('ui_blob'));
		blob.anchor.set(0.5);
		blob.position.set((common.STAGE_WIDTH * 0.5) + 25, (common.STAGE_HEIGHT * 0.5));
		this.addChild(blob);

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_large_out');
		states.over = P3.assets.texture('ui_btn_large_over');
		states.down = P3.assets.texture('ui_btn_large_down');
		states.icon = P3.assets.texture('ui_icon_play');

		const playButton = new P3.Button(states);
		playButton.clickSoundName = 'sfx_btn_press_00';
		playButton.overSoundName = 'sfx_btn_rollover_00';
		playButton.signals.click.add(() => {
			return this.signals.previous.dispatch(this);
		}, this);
		playButton.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5) - 75);
		this.addChild(playButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_home');

		const homeButton = new P3.Button(states);
		homeButton.clickSoundName = 'sfx_btn_press_00';
		homeButton.overSoundName = 'sfx_btn_rollover_00';
		homeButton.signals.click.add(() => {
			common.t.track('game exit event', {gamelevel: common.currentLevel, gameexit: 1});
			return this.signals.next.dispatch('home');
		}, this);
		homeButton.position.set((common.STAGE_WIDTH * 0.5) - 125, (common.STAGE_HEIGHT * 0.5) + 50);
		this.addChild(homeButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_levels');

		const levelButton = new P3.Button(states);
		levelButton.clickSoundName = 'sfx_btn_press_00';
		levelButton.overSoundName = 'sfx_btn_rollover_00';
		levelButton.signals.click.add(() => {
			common.t.track('game exit event', {gamelevel: common.currentLevel, gameexit: 1});
			return this.signals.next.dispatch('level');
		}, this);
		levelButton.position.set((common.STAGE_WIDTH * 0.5) - 50, (common.STAGE_HEIGHT * 0.5) + 100);
		this.addChild(levelButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_help');

		const tutorialButton = new P3.Button(states);
		tutorialButton.clickSoundName = 'sfx_btn_press_00';
		tutorialButton.overSoundName = 'sfx_btn_rollover_00';
		tutorialButton.signals.click.add(() => {
			return this.signals.next.dispatch('tutorial');
		}, this);
		tutorialButton.position.set((common.STAGE_WIDTH * 0.5) + 50, (common.STAGE_HEIGHT * 0.5) + 100);
		this.addChild(tutorialButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_sound_on');
		states.iconAlt = P3.assets.texture('ui_icon_sound_off');

		const muteButton = new P3.MuteButton(states);
		muteButton.position.set((common.STAGE_WIDTH * 0.5) + 125, (common.STAGE_HEIGHT * 0.5) + 50);
		muteButton.signals.click.add(common.toggleAudio);
		muteButton.clickSoundName = 'sfx_btn_press_00';
		muteButton.overSoundName = 'sfx_btn_rollover_00';
		this.addChild(muteButton);

		const ben = new PIXI.Sprite(P3.assets.texture('ui_char_ben'));
		ben.anchor.set(0.5, 1);
		ben.position.set((common.STAGE_WIDTH * 0.5) - 225, common.STAGE_HEIGHT);
		this.addChild(ben);
	}

	_createHorizontalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 0.7);
			line.rotation = (P3.math.random(-5, 5) * PIXI.DEG_TO_RAD) + (90 * PIXI.DEG_TO_RAD);
			line.height = common.STAGE_WIDTH;
			line.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT / count) * i);
			this.addChild(line);

			// up-down anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					y: line.position.y + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	_createVerticalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));
			const angle = P3.math.random(-10, 10);

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 1);
			line.rotation = angle * PIXI.DEG_TO_RAD;
			line.height = common.STAGE_HEIGHT;
			line.position.set((common.STAGE_WIDTH / count) * i, (common.STAGE_HEIGHT * 0.5));
			this.addChild(line);

			// left-right anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					x: line.position.x + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	destroy() {
		super.destroy();
	}

	update() {
		super.update();

		this.bg.width = Math.max(2000, P3.View.width);
	}
}
